import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {putReservationApproveReject as putReservationApproveRejectAPI} from '../../../services/groups'

export async function putApproveReject(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await putReservationApproveRejectAPI(data)
    dispatch({type: SUCCESS, payload: {data: response}})
    return response
  } catch (e) {
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
